import { Coordinate } from '../navigation/coodinate';
import { z } from 'zod';

export type BaseProduct = z.infer<typeof BaseProduct>;

export const BaseProduct = z.object({
    itemId: z.string(),
    rootItemId: z.string(),
    gtin: z.string().nullish(),
    gtins: z.string().array(),
    name: z.string(),
    brand: z.string().nullish(),
    commodityGroupId: z.string().nullish(),
    disableDiscountCodes: z.string().array().nullish(),
    cgIcon: z.string().nullish(),
    cgLocalKey: z.string().nullish(),
    positions: Coordinate.array().nullish(),
    age: z.number().nullish(),
    isDiscountable: z.boolean().nullish(),
    capacity: z.number().nullish(),
    x: z.number().nullish(),
    y: z.number().nullish(),
    forceActive: z.boolean().nullish(),
    weight: z.number().nullish(),
    disableRemovalFromBasket: z.boolean().nullish(),
    isStoreBrand: z.boolean().nullish(),
    isInSpecialityMarket: z.boolean().nullish(),
    tags: z.string().array().nullish(),
});
